import { TafiffSummary } from '../api/tariffSummaryApi';
import { CellLayout } from 'src/common/components/ConfigurableTable/Components/Cells/CellLayout';
import { GetElementType } from 'src/common/tsHelpers';
import { TariffSummaryUsageCellDisplay } from './TariffSummaryUsageCellDisplay';
import React from 'react';
import { toLocaleBrowserSettings } from 'src/i18n/numberLocale';

type TariffSummarySMSUsageCellProps = {
  row: GetElementType<TafiffSummary['items']>;
};

export const TariffSummaryDataUsageCell = React.memo(
  ({
    row: {
      usedData,
      allowanceData,
      forecastData,
      consumptionLevelForecastUsed,
      consumptionLevelUsedUsed,
    },
  }: TariffSummarySMSUsageCellProps) => {
    return (
      <CellLayout>
        <TariffSummaryUsageCellDisplay
          {...(usedData == null
            ? { usage: null, forecast: null, allowence: null, consumptionLevelUsage: null, consumptionLevelForecast: null }
            : { usage: usedData, forecast: forecastData!, allowence: allowanceData!, consumptionLevelUsage: consumptionLevelUsedUsed!, consumptionLevelForecast: consumptionLevelForecastUsed! }
          )}
          valueFormater={toLocaleBrowserSettings}
        />
      </CellLayout>
    );
  },
);
